import React from "react"
import { ConsentManagerProvider } from "@c15t/react"
import { options } from "cookiesConsent/infrastructure/c15t/config/options"

interface C15tProviderProps {
  children: React.ReactNode
}

const C15tProvider = ({ children }: C15tProviderProps) => (
  <ConsentManagerProvider options={options}>{children}</ConsentManagerProvider>
)

export default C15tProvider
